

import React, { useMemo } from 'react';

// Fix: Define an interface for completed test objects to resolve type errors.
interface CompletedTest {
    name: string;
    attempted_at: string;
    score: number;
    no_q: number;
}

const parseAttemptDate = (dateString) => {
    const parts = dateString.split(' ');
    if (parts.length < 2) return new Date(0);
    const dateParts = parts[0].split('/');
    const timeParts = parts[1].split(':');
    
    if (dateParts.length !== 3 || timeParts.length !== 3) return new Date(0);

    const day = parseInt(dateParts[0], 10);
    const month = parseInt(dateParts[1], 10) - 1;
    const year = parseInt(dateParts[2], 10);
    
    let hours = parseInt(timeParts[0], 10);
    const minutes = parseInt(timeParts[1], 10);
    const seconds = parseInt(timeParts[2], 10);

    if (parts[2] && parts[2].toLowerCase() === 'pm' && hours < 12) {
        hours += 12;
    }
    if (parts[2] && parts[2].toLowerCase() === 'am' && hours === 12) {
        hours = 0;
    }
    
    return new Date(year, month, day, hours, minutes, seconds);
};


// FIX: Add explicit types for props to allow 'key' prop in map.
const AttemptRow: React.FC<{ attempt: CompletedTest }> = ({ attempt }) => {
    const accuracy = attempt.no_q > 0 ? Math.round((attempt.score / (attempt.no_q * 4)) * 100) : 0;
    return (
        <tr className="border-b border-brand-border last:border-b-0">
            <td className="py-3 pr-2">
                <p className="font-semibold text-sm text-brand-text-primary">{attempt.name}</p>
                <p className="text-xs text-brand-text-secondary">{new Date(parseAttemptDate(attempt.attempted_at)).toLocaleDateString()}</p>
            </td>
            <td className="py-3 px-2 text-center text-sm font-medium text-brand-primary">{attempt.score}</td>
            <td className="py-3 px-2 text-center text-sm font-medium text-brand-secondary">{Math.max(0, accuracy)}%</td>
            <td className="py-3 pl-2 text-right">
                <button className="text-xs font-semibold text-brand-primary hover:underline">Review</button>
            </td>
        </tr>
    );
};

export const PastAttempts = ({ completedTests }) => {
    const sortedTests = useMemo(() => {
        if (!completedTests) return [];
        // Fix: Cast the array of tests to the correct type to allow sorting.
        return (Object.values(completedTests) as CompletedTest[])
            .sort((a, b) => parseAttemptDate(b.attempted_at).getTime() - parseAttemptDate(a.attempted_at).getTime());
    }, [completedTests]);

  return (
    <div className="bg-brand-surface border border-brand-border rounded-xl p-5">
      <h3 className="font-bold text-lg mb-4 text-brand-text-primary">Past Attempts</h3>
      {sortedTests.length > 0 ? (
        <>
            <div className="overflow-x-auto">
                <table className="w-full">
                    <thead>
                        <tr className="border-b-2 border-brand-border">
                            <th className="pb-2 text-left text-xs font-semibold uppercase text-brand-text-secondary">Mock Name</th>
                            <th className="pb-2 text-center text-xs font-semibold uppercase text-brand-text-secondary">Score</th>
                            <th className="pb-2 text-center text-xs font-semibold uppercase text-brand-text-secondary">Accuracy</th>
                            <th className="pb-2"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedTests.map((attempt, index) => <AttemptRow key={index} attempt={attempt} />)}
                    </tbody>
                </table>
            </div>
            <button className="w-full mt-4 text-sm font-semibold py-2 px-4 rounded-lg bg-brand-primary/10 hover:bg-brand-primary/20 text-brand-primary transition-colors">
                See Full History
            </button>
        </>
      ) : (
        <p className="text-center text-sm text-brand-text-secondary py-8">You haven't completed any tests yet.</p>
      )}
    </div>
  );
};